/**
 * Canonical "app chrome" header look for GENERIC (non-module) surfaces — a dark
 * violet-slate base with subtle violet→cyan neon accents, matching the sidebar.
 *
 * Module workspaces keep their own identity gradient (teal = Blot, purple/pink =
 * ALMA) so they stay instantly recognisable. Everything else (home, admin,
 * whiteboard, …) uses THIS, so the app chrome reads as one calm system instead of
 * a rainbow — and generic surfaces stop imitating module colours.
 */

/** Base gradient for a generic header hero. Use on `bgGradient`. */
export const CHROME_HEADER_GRADIENT = 'linear(135deg, #1e1b34 0%, #171426 55%, #100e1c 100%)'

/** 1px violet→cyan gradient border (glass edge), applied via a masked pseudo. */
export const CHROME_GLASS_BORDER = {
  content: '""',
  position: 'absolute' as const,
  inset: 0,
  borderRadius: 'inherit',
  padding: '1px',
  background:
    'linear-gradient(135deg, rgba(167,139,250,0.6), rgba(34,211,238,0.4) 45%, transparent 75%)',
  WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
  WebkitMaskComposite: 'xor',
  maskComposite: 'exclude',
  pointerEvents: 'none' as const,
}

/** Radial violet aurora blob (top). Spread on an absolutely-positioned Box `bg`. */
export const CHROME_AURORA_VIOLET =
  'radial-gradient(circle, rgba(167,139,250,0.22) 0%, transparent 70%)'
/** Radial cyan aurora blob — the second tone. */
export const CHROME_AURORA_CYAN =
  'radial-gradient(circle, rgba(34,211,238,0.16) 0%, transparent 70%)'
